import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import './Success.css'
import proclass from '../../assets/images/proclass.png';
import honeywell from '../../assets/images/honeywell.png';
import donaldson from '../../assets/images/donaldson.png';
import SdCardIcon from '@mui/icons-material/SdCard';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DrawIcon from '@mui/icons-material/Draw';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ArticleIcon from '@mui/icons-material/Article';


// Example images (replace these with real project images)
const images:string[] = [
 proclass, // Document automation
 donaldson,
 honeywell
];

const stories = [
  {
    category: "Document Management & Automation",
    color: "#6C7FF7",
    title: "Digital Automation for Proclass BV, Netherlands",
    desc: `Provided a Digital Automation solution for Proclass BV and their clients by converting all old hard copy drawings and documentation into searchable PDF documents with specific access...`,
    highlights: [
      { icon: <SdCardIcon fontSize="small" />, text: "Digital document conversion" },
      { icon: <PeopleOutlineIcon fontSize="small" />, text: "Secure, specific access control" },
    ],
    url: "#",
    img: images[0],
  },
  {
    category: "Industrial Manufacturing",
    color: "#5662F6",
    title: "Cost Reduction for Donaldson Middle East Filtration Systems LLC",
    desc: `Significantly reduced the cost of CAD Design & Detail Engineering Services for Donaldson in Abu Dhabi. We designed huge industrial air filters, some as large as 50 feet × 50 feet.`,
    highlights: [
      { icon: <CurrencyExchangeIcon fontSize="small" />, text: "Significant cost reduction" },
      { icon: <DrawIcon fontSize="small" />, text: "Complex large-scale design" },
    ],
    url: "#",
    img: images[1],
  },
  {
    category: "Technology & Engineering",
    color: "#8663F7",
    title: "Productivity Improvement for Honeywell USA",
    desc: `Helped Honeywell USA drastically improve productivity for both Mechanical and Electrical CAD design & detail drawings by customizing CAD software and automating 2D and 3D drawings...`,
    highlights: [
      { icon: <RocketLaunchIcon fontSize="small" />, text: "Drastic productivity improvement" },
      { icon: <ArticleIcon fontSize="small" />, text: "CAD software customization" },
    ],
    url: "#",
    img: images[2],
  },
];

const SuccessStoriesSection: React.FC = () => (
  <div className="stories-bg">
    <Container>
      <div className="text-center mb-4">
        <h2 className="stories-title">
          Our <span className="brand-gradient-text">Success Stories</span>
        </h2>
        <div className="stories-subtitle mx-auto">
          Discover how our solutions have transformed businesses and delivered measurable results, showcasing our expertise in CAD and AI.
        </div>
      </div>
      <Row className="justify-content-center">
        {stories.map((story, idx) => (
          <Col key={story.title} md="6" lg="4" className="mb-4 d-flex">
            <Card className="story-card flex-fill">
              <div className="story-img-wrap">
                <img src={story.img} alt={story.title} className="story-img" />
              </div>
              <CardBody>
                <div
                  className="story-category mb-1"
                  style={{ color: story.color }}
                >
                  {story.category}
                </div>
                <h5 className="mt-2 mb-2 fw-bold">{story.title}</h5>
                <p className="story-desc mb-2">{story.desc}</p>
                <ul className="story-highlights mb-3">
                  {story.highlights.map((h, j) => (
                    <li key={j}><span className="story-icon">{h.icon}</span>{h.text}</li>
                  ))}
                </ul>
                {/* <a href={story.url} className="read-more-link">
                  Read Full Case Study &rarr;
                </a> */}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </div>
);

export default SuccessStoriesSection;
